module.exports = __webpack_public_path__ + "320bc6ee96b04d2286db1c10145197f9.png";